<template>
  <v-card>
    <v-flex class="text-xs-center" pt-3>
      <h2>{{ message.title }}</h2>
    </v-flex>
    <v-card-text class="text-xs-center">
      <p>{{ message.text }}</p>
    </v-card-text>
    <v-card-actions>
    <v-spacer></v-spacer>
    <v-flex mb-3>
      <v-btn
        color="error"
        @click="fihishCreateMission"
      >
        <v-icon left>close</v-icon>
        Terminar
      </v-btn>
      <v-btn 
        color="success"                    
        @click="nextMission"
      >
        <v-icon left>add</v-icon>
        Continuar
      </v-btn>
    </v-flex>
  </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'create-mission-message',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  methods: {
    fihishCreateMission() {
      this.$emit('fihishCreateMission')
    },
    nextMission() {
      this.$emit('nextMission')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Missions/CreateMissionMessage.vue